import { useState, memo, useCallback } from "react";
// import { useMousePosition } from "@hooks/useMousePosition";
import { useRouter } from "next/router";
import { useStore } from "@hooks/useZustandProvider";
import Loading from "@ui-kit/Loading/Loading";
import { collectionType } from "../../cmsBlocks/AdvBannerBlock/datas";
import { useGetWidget } from "@api/hooks/queries/useGetSet";
import AdvBannerBlockLayout from "@components/cmsBlocks/AdvBannerBlock/AdvBannerBlock.layout";

const AdvBannerWidget = (props) => {

  const { locale } = useRouter();
  const { cms, updateCollectionType } = useStore();
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const { isEditMode } = cms.uiOptions;
  const cursorNotice = "Double click to edit banner";

  const [items, setItems] = useState([])

  const id = 95;

  const handleClickToEdit = useCallback((e) => {
    switch (e.detail) {
      case 2: // double click
        updateCollectionType(e);
    }
  }, []);

  const { loading } = useGetWidget({
    options: {
      variables: {
        id,
        language: locale,
      },
    },
    onCompleted: (data) => {
      const widget = data?.getWidget;

      const items = widget.languages.data.collections[collectionType].items;

      setItems(items);
    },
    onCompleteWithError: (data) => {
      const widget = data?.getWidget;

      if (!widget) {
        toast.error(`Widget ${id} for ${language} locale not found`);
      }
    },
  })

  return (
    <AdvBannerBlockLayout
      {...props}
      loading={loading}
      items={items}
      isEditMode={isEditMode}
      isWidgetEditing={isWidgetEditing}
      isWidget={isWidget}
      cursorNotice={cursorNotice}
      collectionType={collectionType}
      handleClickToEdit={handleClickToEdit}
    />
  )

  // return loading ? (
  //   <Loading />
  // ) : (
  //   items.length ? (
  //     <AdvBannerBlockLayout
  //       {...props}
  //       loading={loading}
  //       items={items}
  //       isEditMode={isEditMode}
  //       isWidgetEditing={isWidgetEditing}
  //       isWidget={isWidget}
  //       cursorNotice={cursorNotice}
  //       collectionType={collectionType}
  //       handleClickToEdit={handleClickToEdit}
  //     />
  //   ) : null

  // );
};

export default memo(AdvBannerWidget);
